

export const API_URL = import.meta.env.MODE === 'production'
    ? "https://www.themeaterybh.com"
    : "https://www.themeaterybh.com";
export const API_URL_2 = import.meta.env.MODE === 'production'
    ? "https://www.themeaterybh.com"
    : "https://www.themeaterybh.com";

export const API_ENDPOINT = {
    auth: '/auth/api/',
    page: '/page/api/',
    order: '/order/api/',
}